const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const ENABLED = process.env.REACT_APP_META_PIXEL_ENABLED === "true" && Boolean(PIXEL_ID);

export function isMetaPixelReady() {
  return ENABLED && typeof window !== "undefined";
}

export function loadMetaPixel() {
  if (!isMetaPixelReady() || window.fbq) return;

  // Standard Meta base code (queue-compatible stub)
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

  window.fbq("init", PIXEL_ID);
  // Exactly one initial PageView (the base-code event)
  window.fbq("track", "PageView");
}

export function track(eventName, params = {}) {
  if (isMetaPixelReady() && typeof window.fbq === "function") {
    window.fbq("track", eventName, params);
  }
}
